<template>
  <v-dialog persistent v-model="get_MainFormDialog.dialog" :width="get_MainFormDialog.with" justify-center>
    <v-card>
      <v-card-title class="text-h5 blue-grey lighten-3">
        <v-icon v-if="get_MainFormDialog.icon" large left color="primary">{{get_MainFormDialog.icon}}</v-icon>
        <span class="text-h5 font-weight-bold">{{get_MainFormDialog.title}}</span>
        <v-spacer/>
        <v-btn icon dark @click="HIDDEN_MAIN_FORM_DIALOG()">
          <v-icon large color="primary">mdi-close</v-icon>
        </v-btn>
      </v-card-title>
        <MainGeneralForm v-if="showFormSecound" :form="formSecound" :model="objectSecound" :on-success="save" :on-cancel="cancel"/>
      <v-card-text></v-card-text>
    </v-card>
    <!-- <ImportDataForm v-else :itemAction="form" :on-success="saveImport" :on-cancel="cancel"/> -->
  </v-dialog>
</template>
<script>
import { mapActions, mapGetters, mapMutations } from 'vuex'
import MainGeneralForm from '@/components/forms/main/MainGeneralForm'
// import ImportDataForm from '@/components/forms/main/ImportDataForm'
export default {
  props: [],
  data: () => ({
    model: null,
    params: null,
    body: null,

    showFormSecound: false,
    formSecound: {},
    objectSecound: {},

    paramsForm: {}
  }),
  components: {
    MainGeneralForm
    // ImportDataForm
  },
  mounted () {
    this.model = this.get_MainFormDialog.body.objectMain
    this.params = this.get_MainFormDialog.body.paramsDialog
    this.body = this.get_MainFormDialog.body

    // this.paramsForm = (this.params.paramsForm) ? this.params.paramsForm : {}
    if (this.params.form) {
      this.formSecound = JSON.parse(JSON.stringify(this.params.form))
      if (this.params.setmodel) this.objectSecound = Object.assign({}, this.model)
      this.showFormSecound = true
    } else if (this.body.form === 'process') {
    }
  },
  methods: {
    ...mapActions(['postServiceAction', 'putServiceAction', 'postServiceActionMultipart', 'postUrlExportDataServerAction', 'postUrExporPdftDataServerAction']),
    ...mapMutations(['HIDDEN_MAIN_FORM_DIALOG', 'SHOW_MAIN_PROGRESS_DIALOG', 'RESPONSE_DATA_DIALOG', 'CLEAR_DATA', 'SET_DATA']),
    save (model) {
      if (this.body && this.body.exportpdf) {
        this.postUrExporPdftDataServerAction({ url: this.params.url, data: model, params: this.body.params, replace: this.body.replace })
        this.cancel()
        return
      } else if (this.body && this.body.exportexcel) {
        if (this.body.loadding) this.SHOW_MAIN_PROGRESS_DIALOG(this.body.processLoadding)
        this.postUrlExportDataServerAction({ url: this.params.url, nombre: this.body.nameFile, data: model })
        this.cancel()
        return
      } else if (this.body && this.body.formData) {
        const formData = this.createFormData(model, this.params.form)
        if (this.body.loadding) this.SHOW_MAIN_PROGRESS_DIALOG(this.body.processLoadding)
        this.postServiceActionMultipart({ url: this.params.url, data: formData })
        this.cancel()
        return
      }

      if (this.params.url.method === 'PUT') {
        this.putServiceAction({ url: this.params.url, data: model, params: `${model.id}`, replace: '{id}' })
      } else {
        this.postServiceAction({ url: this.params.url, data: model })
      }
      // this.cancel()
    },
    createFormData (object, form) {
      const formData = new FormData()
      form.map((field) => {
        formData.append(`${field.nameid}`, object[field.nameid])
      })
      return formData
    },
    saveImport (model) {
      console.log('model', model)
      // this.postServiceAction({ url: this.urls, data: model })
    },
    cancel () {
      this.HIDDEN_MAIN_FORM_DIALOG()
    }
  },
  computed: {
    ...mapGetters(['get_MainFormDialog', 'get_urls', 'get_object'])
  },
  watch: {
    get_object (val) {
      if (val.message) {
        this.$swal({
          type: 'error',
          icon: 'error',
          title: 'Error!',
          text: val.message
        })
        return
      }

      this.$swal({
        type: 'success',
        icon: 'success',
        title: 'Exitoso!',
        text: this.message
      })
      if (this.get_MainFormDialog.body && this.get_MainFormDialog.body.content === 'form-data') {
        this.cancel()
        return
      } else if (this.get_MainFormDialog.body && this.get_MainFormDialog.body.exportpdf) {
        const linkSource = `data:application/pdf;base64,${val.pdf}`
        const downloadLink = document.createElement('a')
        downloadLink.href = linkSource
        downloadLink.download = val.nombre
        downloadLink.click()
        this.cancel()
        return
      } else if (this.get_MainFormDialog.returned) {
        console.log(this.get_MainFormDialog.returned)
        this.RESPONSE_DATA_DIALOG({ name: this.get_MainFormDialog.identity, model: val })
        this.cancel()
        return
      }
      this.SET_DATA(val)
      // this.CLEAR_DATA()
      this.cancel()
    }
  }
}
</script>

<style></style>
